import React, { useState } from "react";

export default function DonationModal({ visible, onClose }) {
  if (!visible) return null;

  const bankDetails = `Moniepoint Microfinance Bank\nAccount Name: James Abraham\nAccount Number: 7014604466`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(bankDetails);
    alert("Bank details copied to clipboard!");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-xl max-w-sm w-full p-6 text-center" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-2xl font-bold text-primary mb-1">Support VerSeer</h2>
        <p className="text-gray-500 text-sm mb-6">Choose your donation method</p>

        <button
          onClick={() => window.open("https://www.paypal.com/donate/?hosted_button_id=7W4B8DFDXPTEQ", "_blank")}
          className="w-full bg-cream text-primary font-semibold py-2 px-4 rounded-full mb-3 hover:bg-opacity-80 transition"
        >
          PayPal
        </button>

        <button
          onClick={() => window.open("https://flutterwave.com/pay/yavcj8146yqw", "_blank")}
          className="w-full bg-cream text-primary font-semibold py-2 px-4 rounded-full mb-3 hover:bg-opacity-80 transition"
        >
          Flutterwave (Card & Bank Transfer)
        </button>

        <button
          onClick={() => {
            copyToClipboard();
            alert("Bank details copied to clipboard");
          }}
          className="w-full bg-cream text-primary font-semibold py-2 px-4 rounded-full mb-4 hover:bg-opacity-80 transition"
        >
          Nigerian Bank Transfer (Copy Details)
        </button>

        <button onClick={onClose} className="text-gray-400 text-sm hover:text-gray-600 transition">
          Close
        </button>
      </div>
    </div>
  );
}